import { render, staticRenderFns } from "./MentionsTable.vue?vue&type=template&id=581c9080&scoped=true&"
import script from "./MentionsTable.vue?vue&type=script&lang=js&"
export * from "./MentionsTable.vue?vue&type=script&lang=js&"
import style0 from "./MentionsTable.vue?vue&type=style&index=0&id=581c9080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c9080",
  null
  
)

export default component.exports